import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute  } from '@angular/router';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import  * as XLSX  from 'xlsx';
import { environment } from '../../../../environments/environment';



import {
  ColDef,
  CellValueChangedEvent,
  RowValueChangedEvent,
  ICellEditorComp,
  GridReadyEvent,
  ValueSetterParams,
} from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-enterprise';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { GridService } from 'src/app/_services/grid.service';

@Component({
  selector: 'app-rsa-edit',
  templateUrl: './rsa-edit.component.html',
  styleUrls: ['./rsa-edit.component.css'],
  providers: [ConfirmationService, MessageService]
})

export class RsaEditComponent implements OnInit {
  elementType = NgxQrcodeElementTypes.URL;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  societalist:any[]=[];
  societasel;
  operazioniItems: MenuItem[];
  showCaricaResidenze=false;
  myReader:FileReader = new FileReader();
  XLSX: any;

  public editType = 'fullRow';
  public columnDefs: ColDef[] = [
    { field: 'id', hide: true },
   
    { field: 'code',  editable: true, headerName:'Code',cellEditor: 'agTextCellEditor'},
    { field: 'description',editable: true, headerName:'Description',cellEditor: 'agTextCellEditor'},
    { field: 'availability',  editable: true, headerName:'Availability',
      valueSetter: (params: ValueSetterParams) => {  //to make sure user entered number only
        var newValInt = parseInt(params.newValue);
        var valueChanged = params.data.availability !== newValInt;
        if (valueChanged) {
          params.data.availability = newValInt ? newValInt : params.oldValue;
  
        }
  
        return valueChanged;
      },
    },
    { field: 'id',  
      headerName: '', 
      editable: false,
      sortable:false,
      maxWidth:150,
      minWidth:150,
      cellRenderer: params =>    {   
        return '<a title="Delete row" style="cursor:pointer;"><i class=" pl-2 feather ft-trash pointer"></i> Remove</a>'; 
      },
      onCellClicked:function(data){ 
        _this.gridApi.applyTransaction({
          remove: [data.data]
        });
      }   
    },
  ];
  showQR=false;
  QrCode='';

  isEditing=false;
  action='';  
  ID:number;
  defaultColDef = {
    width: 250,
    minWidth: 100,
    sortable:true,
    flex:1
  };

  breadcrumbs: MenuItem[];
  gridApi:any;
  rsa:any={
    id:'',
    name:'',
    website:'',
    rsalist:[]
  };
  


  errors: {
    rsaNameError: boolean,
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private messageService: MessageService,
    public globalService: GlobalService,
    public gridService: GridService,
  ) { }

  ngOnInit(): void {
    _this=this;
    this.initErrors();  
    this.operazioniItems=[
      {
        label:'Carica residenze', 
        command: () => {
          this.showCaricaResidenze=true;
        }
      },
      {
        label:'Svuota elenco', 
        command: () => {
          this.azzera();
        }
      },
    ];


    this.action=this.route.snapshot.paramMap.get('action');
    this.ID=null;
    if (this.route.snapshot.paramMap.get('id')) {
        this.ID=parseInt(this.route.snapshot.paramMap.get('id'));
        this.apiService.get('surveys-rsa/listall',{}).subscribe(data => {
          for (const g of data.Result) {
            if(g['id']==this.ID){
              this.rsa=g;
            }
          }
        });
    }
    this.apiService.get('surveys/societalistall',{}).subscribe(data => {
      this.societalist=data.Result;
    });
  }

  
  private initErrors() {
    this.errors = {} as any;
    this.errors.rsaNameError = false;

  }

  private validate() : boolean {
    let isValid : boolean = true;
    
    if (this.rsa.name=='') {
      this.errors.rsaNameError = true;
      isValid = false;
    }
    return isValid;
  }


  save(){
    this.initErrors();
    if (!this.validate()) return;
    if(this.ID){
      this.rsa.id=this.ID;
    } else {
      delete this.rsa['id'];
    }
   
    this.rsa.rsalist=[];
   
    this.gridApi.forEachNode((node) =>{
   

      if((node.data)&&(node.data.code)&&(node.data.description)&&(node.data.code!='')&&(node.data.description!='')){
        
        this.rsa.rsalist.push(node.data);
      }
      
    });
  

    this.apiService.updatersa(this.rsa).subscribe(data => {
      this.addSingle('success', 'Successo', 'Saved');
      this.router.navigateByUrl('/dashboard/surveys/rsa');
    });
  }
  
  addRow()
  {
    let row={
      Id:'-1',
      code:'',
      description:''
    };
    const transaction = {
      add: [row]
    };
    this.gridApi.applyTransaction(transaction);
    let rowDatalength = 0;
    this.gridApi.forEachNode(node => rowDatalength++);
    this.gridApi.startEditingCell({
      rowIndex: rowDatalength-1,
      colKey: 'code',
    });
  }
  
  
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }


  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.showLoadingOverlay();
  }
  
  onrowEditingStopped($event) {
   
      this.isEditing=false;
   
  }
  onRowEditingStarted($event) {
  
  }
  onCellValueChanged(event:CellValueChangedEvent) {
  }

  onRowValueChanged(event:RowValueChangedEvent) {

  }
  chiudiQR(){
    this.showQR=false;
  }

  changeListener($event) : void {
    this.readThis($event.files[0]);
  }

  readThis(file:File) : void {
   
    

    this.myReader.onloadend = (e)=>{
      // you can perform an action with readed data here

      var workbook = this.convertDataToWorkbook(this.myReader.result);

    this.populateGrid(workbook);
    }

    this.myReader.readAsArrayBuffer(file);
    
  }

  convertDataToWorkbook(dataRows) {
    /* convert data to binary string */
    var data = new Uint8Array(dataRows);
    var arr = [];

    for (var i = 0; i !== data.length; ++i) {
      arr[i] = String.fromCharCode(data[i]);
    }

    var bstr = arr.join('');

    return XLSX.read(bstr, { type: 'binary' });
  }


 populateGrid(workbook: any) {
  // our data is in the first sheet
  var firstSheetName = workbook.SheetNames[0];
  var worksheet = workbook.Sheets[firstSheetName];

  // we expect the following columns to be present
  var columns: Record<string, string> = {
    A: 'code',
    B: 'description'
  };

  var rowData = [];

  // start at the 2nd row - the first row are the headers
  var rowIndex = 2;

  // iterate over the worksheet pulling out the columns we're expecting
  var counter=0;
  while (worksheet['A' + rowIndex]) {
    var row: any = {};
    Object.keys(columns).forEach(function (column) {
      if(worksheet[column + rowIndex]){
        row[columns[column]] = worksheet[column + rowIndex].w;
      }else {
        row[columns[column]] = '';
      }
    
    });
    row['id'] = counter;
    rowData.push(row);
    counter++;
    rowIndex++;
  }

  // finally, set the imported rowData into the grid
 // this.gridApi.setRowData(rowData);
 this.rsa.rsalist=rowData;
 this.gridApi.redrawRows();
}
downloadmodel(){
  
  window.open(environment.QUESTIONARI_URL+'residencesmodel.xlsx', '_blank').focus();
  }
azzera(){
  this.rsa.rsalist=[];
  this.gridApi.redrawRows();
}
  loadres(){
    this.apiService.get('surveys/rsapersocietalistall',{idSocieta:this.societasel}).subscribe(data => {
  
      this.rsa.rsalist=this.rsa.rsalist.concat(data.Result);
      this.gridApi.redrawRows();
      this.showCaricaResidenze=false;
    });
   
  }
}
var _this;